
const digest = '346cffafda88e62b4642173d19bcc22eceb3fc3ecb92ae1979b665188c750df7';
const css = `._selectionRectangle_1lsko_1 {
  display: flex;
  position: relative;
  border-radius: 4px;
  outline-offset: 0px;
  max-width: 100%;
}

._selectionRectangleInline_1lsko_9 {
  display: inline-flex;
}

._selectionRectangleSelected_1lsko_13 {
  outline: 2px solid rgb(var(--aha-editor-v2--selection-outline-color));
}

._selectionRectangleMargin_1lsko_17 {
  outline-offset: 2px;
}

._selectionRectangleBackground_1lsko_21 {
  background-color: var(--aha-blue-100);
}

._selectionRectangleFill_1lsko_25 {
  width: 100%;
  height: 100%;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionRectangle":"_selectionRectangle_1lsko_1","selectionRectangleInline":"_selectionRectangleInline_1lsko_9","selectionRectangleSelected":"_selectionRectangleSelected_1lsko_13","selectionRectangleMargin":"_selectionRectangleMargin_1lsko_17","selectionRectangleBackground":"_selectionRectangleBackground_1lsko_21","selectionRectangleFill":"_selectionRectangleFill_1lsko_25"};
export { css, digest };
  